import { generateTokenFn } from './tokens';
export var icon = {
  styles: function styles(_ref) {
    var target = _ref.target,
        color = _ref.color,
        size = _ref.size;
    return {
      color: generateTokenFn({
        target: target,
        type: 'icon.color',
        tokenKey: 'color.textStyle',
        fallback: color
      }),
      height: generateTokenFn({
        target: target,
        type: 'icon.size',
        tokenKey: 'icon.size',
        fallback: size
      }),
      width: generateTokenFn({
        target: target,
        type: 'icon.size',
        tokenKey: 'icon.size',
        fallback: size
      })
    };
  },
  tokens: function tokens(_ref2) {
    var target = _ref2.target,
        color = _ref2.color,
        size = _ref2.size,
        svg = _ref2.svg;
    return {
      icon: {
        color: generateTokenFn({
          target: target,
          type: 'icon.color',
          tokenKey: 'color.textStyle',
          fallback: color
        }),
        size: generateTokenFn({
          target: target,
          type: 'icon.size',
          tokenKey: 'icon.size',
          fallback: size
        }),
        svg: generateTokenFn({
          target: target,
          type: 'icon.svg',
          tokenKey: 'icon.svg',
          fallback: svg
        })
      }
    };
  }
};